import { render, staticRenderFns } from "./CampaignNew.vue?vue&type=template&id=33af73d2&"
import script from "./CampaignNew.vue?vue&type=script&lang=ts&"
export * from "./CampaignNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports